import getCurrentMode from './getCurrentMode';
import setCurrentMode from './setCurrentMode';
/**
 * Sets open status of main menu panel
 */
function setOpen(leftDrawerOpen) {
    const mode = getCurrentMode();
    setCurrentMode(Object.assign(Object.assign({}, mode), { leftDrawerOpen }));
}
/** Gets open status of main menu panel */
function getOpen() {
    const mode = getCurrentMode();
    return !!mode.leftDrawerOpen;
}
/** Sets open status of main menu panel to `false` */
function close() {
    setOpen(false);
}
/** Sets open status of main menu panel to `true` */
function open() {
    setOpen(true);
}
/** Toggles open status of main menu panel between `false` and `true` */
function toggle() {
    setOpen(!getOpen());
}
export default {
    setOpen,
    getOpen,
    close,
    open,
    toggle
};
